module.exports = __webpack_public_path__ + "static/media/contact-email-icon.41f24439.svg";